import EditAssessment from "./EditAssessment";

export default function EditPublicAssessment({ language }) {
  return (
    <EditAssessment
      language={language}
      backRoute="/managePublicAssessments"
      backLabelKey="backToAssessments"
    />
  );
}
